// extracted by css-extract-rspack-plugin
export default {"resizableBox":"PTmkR"};